<div class="dx-card padding-content">
    <div
        style="
            display: flex;
            gap: 5px 10px;
            padding: 10px 10px 10px 10px;
            align-items: center;
            justify-content: space-between;
        "
    >
        <div>
            <dx-button
                [style.display]="!selectedFileName ? '' : 'none'"
                [hidden]="selectedFileName"
                id="openFileButton"
                stylingMode="contained"
                icon="xlsxfile"
                type="{{ this.gridDataSource ? '' : 'default' }}"
                text="เปิดไฟล์คลังสินค้า"
                [disabled]="isDataLoading"
            ></dx-button>
        </div>
        <div style="flex-grow: 1">
            @if (selectedFileName) {
            <div style="display: flex; align-items: center">
                <dx-button
                    stylingMode="text"
                    icon="remove"
                    [disabled]="isDataLoading"
                    (onClick)="removeSelectedFile()"
                >
                </dx-button>
                <span
                    style="
                        text-decoration: underline;
                        margin-left: 2px;
                        line-height: 30px;
                    "
                    >{{ selectedFileName }}</span
                >
            </div>
            }
        </div>
        <div style="display: flex; align-items: end; gap: 50px">
            <div
                style="flex-grow: 1; display: flex; align-items: end; gap: 10px"
            >
                <dx-number-box
                    [width]="150"
                    [showSpinButtons]="true"
                    [min]="0"
                    [max]="1"
                    [step]="0.01"
                    [format]="inPriceDiscountDisplayFormat"
                    label="ราคาซื้อ %ลด"
                    labelMode="outside"
                    [disabled]="isDataLoading || selectedRowKeys.length === 0"
                    [(value)]="inPriceDiscountPercent"
                    [width]="100"
                ></dx-number-box>
                <dx-button
                    icon="import"
                    stylingMode="contained"
                    text="เติมข้อมูล{{
                        selectedRowKeys.length > 0
                            ? ' (' + selectedRowKeys.length + ' รายการ)'
                            : ''
                    }}"
                    [disabled]="isDataLoading || selectedRowKeys.length === 0"
                    (onClick)="fillAutoData()"
                ></dx-button>
            </div>
            <div>
                <dx-date-box
                    #requestDateBox
                    [width]="150"
                    label="วันที่ใบกำกับภาษี"
                    labelMode="outside"
                    type="date"
                    invalidDateMessage="วันที่ไม่ถูกต้อง"
                    [acceptCustomValue]="false"
                    [(value)]="taxInvoiceSelectDate"
                    [disabled]="isDataLoading || !gridDataSource"
                    displayFormat="dd MMM yyyy"
                    [inputAttr]="{ 'aria-label': 'Date' }"
                >
                </dx-date-box>
            </div>
            <div>
                <dx-number-box
                    [width]="150"
                    [showSpinButtons]="true"
                    [min]="1"
                    [max]="MAX_ITEM_SUPPORTED_PER_REPORT"
                    [step]="1"
                    label="สินค้าต่อไฟล์"
                    labelMode="outside"
                    [disabled]="isDataLoading || !gridDataSource"
                    [(value)]="itemPerReport"
                    (onValueChanged)="onItemPerReportChanged()"
                ></dx-number-box>
            </div>
            <div>
                <dx-button
                    stylingMode="contained"
                    icon="exportxlsx"
                    type="{{ this.gridDataSource ? 'default' : '' }}"
                    [disabled]="
                        isDataLoading ||
                        selectedRowKeys.length === 0 ||
                        !this.taxInvoiceSelectDate
                    "
                    text="{{
                        estimatedReport > 0
                            ? 'สร้างฟอร์ม (' + estimatedReport + ' ไฟล์)'
                            : 'สร้างฟอร์ม'
                    }}"
                    (onClick)="createForm()"
                ></dx-button>
            </div>
        </div>
    </div>

    @for (result of createFormResults; track result) {
    <dx-box direction="row" crossAlign="center" style="margin: 0px 10px 10px">
        <dxi-item [ratio]="3" style="padding-right: 10px">
            <dx-text-box
                width="100%"
                label="ชื่อไฟล์"
                style="margin-bottom: 7px"
                [value]="result.name"
            >
            </dx-text-box>
        </dxi-item>
        <dxi-item [ratio]="9" style="padding-right: 10px">
            <dx-text-box
                width="100%"
                label="Shared URL"
                style="margin-bottom: 7px"
                [value]="result.webViewLink"
            ></dx-text-box>
        </dxi-item>
        <dxi-item [ratio]="2" style="padding-right: 10px">
            <dx-button
                stylingMode="contained"
                text="คัดลอก"
                icon="copy"
                width="100%"
                (onClick)="copySharedUrlToClibboard(result.webViewLink)"
            ></dx-button>
        </dxi-item>
        <dxi-item [ratio]="2">
            <dx-button
                stylingMode="contained"
                text="เปิดไฟล์"
                icon="link"
                width="100%"
                (onClick)="openSharedUrl(result.webViewLink)"
            ></dx-button>
        </dxi-item>
    </dx-box>
    }

    <dx-data-grid
        #dataGrid
        [disabled]="isDataLoading"
        [dataSource]="gridDataSource"
        [(selectedRowKeys)]="selectedRowKeys"
        [hoverStateEnabled]="true"
        [showBorders]="true"
        [columnAutoWidth]="false"
        [allowColumnResizing]="true"
        [showRowLines]="true"
        [rowAlternationEnabled]="true"
        (onSelectionChanged)="onDataGridSelectionChanged()"
        (onRowUpdating)="onRowUpdating($event)"
        (onCellPrepared)="onCellPrepared($event)"
    >
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-editing [allowUpdating]="true" mode="cell"> </dxo-editing>
        <dxo-selection
            selectAllMode="allPages"
            showCheckBoxesMode="onClick"
            mode="multiple"
        ></dxo-selection>
        <dxi-column
            dataField="no"
            caption="ลำดับที่"
            [width]="70"
            [allowEditing]="false"
        ></dxi-column>
        <dxi-column
            dataField="sku"
            caption="SKU"
            [width]="90"
            alignment="left"
            [allowEditing]="false"
        ></dxi-column>
        <dxi-column
            dataField="productName"
            caption="ชื่อสินค้า (เต็ม)"
            [minWidth]="120"
            [allowEditing]="false"
        ></dxi-column>
        <dxi-column
            dataField="productShortName"
            caption="ชื่อสินค้า (ย่อ)"
            [minWidth]="120"
        ></dxi-column>
        <dxi-column
            dataField="outPrice"
            [width]="95"
            caption="ราคาขาย"
            dataType="number"
            [allowEditing]="false"
            cellTemplate="priceTemplate"
        ></dxi-column>
        <dxi-column
            dataField="inPrice"
            [width]="95"
            caption="ราคาซื้อ"
            dataType="number"
            [allowEditing]="false"
            cellTemplate="priceTemplate"
        ></dxi-column>
        <dxi-column
            dataField="toOrderQuantity"
            [width]="95"
            caption="จำนวนซื้อ"
            dataType="number"
            [allowEditing]="false"
            cellTemplate="numTemplate"
        ></dxi-column>
        <div *dxTemplate="let cellData of 'priceTemplate'">
            {{ cellData.value | formatNumber : 2 }}
        </div>
        <div *dxTemplate="let cellData of 'numTemplate'">
            {{ cellData.value | formatNumber : 0 }}
        </div>
    </dx-data-grid>
</div>
<dx-popup #popupComponent [visible]="false">
    <dx-file-uploader
        #fileSelector
        selectButtonText="เลือกไฟล์คลังสินค้า"
        labelText=""
        accept=".xlsx"
        uploadMode="useForm"
        [multiple]="false"
        dialogTrigger="#openFileButton"
        (onValueChanged)="onInventoryFileSelected($event)"
    >
    </dx-file-uploader>
</dx-popup>
